<template>
    <div>
 <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red darken-2"
          outlined
          v-bind="attrs"
          v-on="on"
        >
          <v-icon left small>mdi-lock-clock</v-icon>
          Travar horário
        </v-btn>
          
          
      </template>

      <v-card>
        <v-card-title class="headline red lighten-2 mb-5">
          Travamento de horário
        </v-card-title>

        <v-card-text>
          Precisa sair por um período de tempo? Trave seu horário enquanto estiver fora!
        </v-card-text>
         

        <v-form ref="form" v-model="valid">
            <v-row justify="center" >
            <v-col cols="10" sm="10" >
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >

                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="date"
                    label="Escolha o dia"
                    prepend-icon="fa fa-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                   :rules="fieldRules"
                    required
                ></v-text-field>
                </template>
                
                <v-date-picker
                locale="pt-br"               
                v-model="date"
                :min="new Date(Date.now() - 86400000).toISOString().substr(0, 10)"
                @change="$refs.menu.save(date)"
                ></v-date-picker>

              
            </v-menu>

               
                <v-select
                    v-model="barbeirosEscolhido"
                     item-text="nome"
                     item-value="id"
                    :items="barbeiros"
                    chips
                    label="Selecione o barbeiro"
                    
                    solo
                ></v-select>
            </v-col>
            <v-col cols="5" sm="5" >  
                <v-text-field type="time" :rules="fieldRules" v-model="horaInit" label="Horário início de saída" ></v-text-field>
            </v-col>
            <v-col cols="5" sm="5" >  
                <v-text-field type="time" :rules="fieldRules" v-model="horaFim" label="Horário fim de saída" ></v-text-field>
            </v-col>
        </v-row>
        </v-form>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary" :loading="salvando" :disabled="!valid || salvando"
            @click="travarHorario"
          >
            Gravar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import {refBarbeiros} from '@/firebaseConfig'
import { criarAgendamentoNoPortal } from '@/services/agendaFirestore'

    export default {
        data(){
            return {
                valid: true,
                refBarbeiros: refBarbeiros,
                salvando: false,
                dialog: false,
                barbeiros: [],
                barbeirosEscolhido: '',
                barbeiroEscolhidoObjeto: {},
                cliente: {},
                horaInit: '',
                horaFim: '',
                date: '',
                menu: '',
                fieldRules: [
                    v => !!v || 'Este campo é obrigatório',
                    
                ],

            }
        },
        created(){
            this.carregarBarbeiros()
        },
        methods: {
            carregarBarbeiros(){
                this.refBarbeiros.get().then((snap)=> {
                    snap.forEach((doc)=>{
                        this.barbeiros.push({...doc.data()})
                    });
                });
            },
            

        async travarHorario(){
            if(this.salvando){
                return
            }

            this.salvando = true
            try {
                const barbeiro = this.barbeiros.find(
                    item => item.id === this.barbeirosEscolhido
                )
                await criarAgendamentoNoPortal({
                    barbeiro: {...barbeiro},
                    servico: {
                        descricao: "Hora travada pelo barbeiro",
                        id: "id",
                        preco: "00.00",
                        tempo: "0m"
                    },
                    cliente: {name: "Hora travada", email: "Travado", telefone: "0"},
                    name: barbeiro.nome + " - HORÁRIO TRAVADO ",
                    start: this.date + "T" + this.horaInit,
                    end: this.date + "T" + this.horaFim,
                    dataQuery: new Date(this.date + "T00:00-03:00").getTime(),
                    status: "Confirmado",
                })

                this.$emit('recarregarLista')
                this.barbeirosEscolhido = ''
                this.date = ''
                this.horaInit = ''
                this.horaFim = ''
                this.dialog = false
            } catch (error) {
                this.$toasted.global.defaultError({ msg: error.message })
            } finally {
                this.salvando = false
            }
          },
        }
    }
</script>

<style lang="scss" scoped>

</style>
